export const downloadFile = ({ url, fileName } : {url: string, fileName: string}): void => {
  const a = document.createElement('a')
  a.href = url
  a.download = fileName
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
}